import { useCallback, useEffect, useState } from 'react';
import { VariableType } from "../../../../services/generated/graphql-types";
import { validateVariableName } from '../../utils';
export const useVariableForm = ({ isEditMode, variableData, externalNameError, clearExternalNameError, }) => {
    const [name, setName] = useState('');
    const [variableType, setVariableType] = useState(VariableType.TableMapping);
    const [sensitive, setSensitive] = useState(false);
    const [nameError, setNameError] = useState(null);
    useEffect(() => {
        if (isEditMode && variableData) {
            const varName = variableData.name || '';
            const varType = variableData.variable_type || VariableType.TableMapping;
            const varSensitive = variableData.sensitive || false;
            setName(varName);
            setVariableType(varType);
            setSensitive(varSensitive);
        }
    }, [isEditMode, variableData]);
    useEffect(() => {
        if (externalNameError && !isEditMode) {
            setNameError(externalNameError);
        }
    }, [externalNameError, isEditMode]);
    useEffect(() => {
        if (externalNameError && name && clearExternalNameError) {
            clearExternalNameError();
        }
    }, [name, externalNameError, clearExternalNameError]);
    const validateForm = useCallback(() => {
        if (!isEditMode) {
            const nameValidation = validateVariableName(name);
            if (nameValidation) {
                setNameError(nameValidation);
                return false;
            }
        }
        setNameError(null);
        return true;
    }, [name, isEditMode]);
    const handleNameChange = useCallback((value) => {
        setName(value);
        const validation = validateVariableName(value);
        setNameError(validation);
    }, []);
    const handlePurposeChange = useCallback((event) => {
        const target = event.target;
        if (target.value) {
            const newType = target.value;
            if (newType === VariableType.FormulaVariable) {
                setSensitive(false);
            }
            setVariableType(newType);
        }
    }, []);
    const handleSensitiveChange = useCallback(() => {
        setSensitive(prev => !prev);
    }, []);
    return {
        name,
        variableType,
        sensitive,
        nameError,
        setName,
        setVariableType,
        setSensitive,
        setNameError,
        handleNameChange,
        handlePurposeChange,
        handleSensitiveChange,
        validateForm,
    };
};
//# sourceMappingURL=useVariableForm.js.map